import request from '../utils/request';
import qs from "qs";
//通话关键词列表
export const getKeywordList = param => {
	return request.get('/api/risk/keyword/findAll?keyTypeId=' + param.keyTypeId + '&&keyword=' + param.keyword +
		'&&gradeTypeId=' + param.gradeTypeId + '&&current=' + param.current + '&&size=' + param.size)
};
//通话关键词 删除
export const getKeywordDelete = param => {
	return request.post('/api/risk/keyword/delete?id=' + param.id)
};
//通话关键词 添加
export const getKeywordImport = param => {
	return request.post('/api/risk/keyword/import', qs.stringify(param))
};
//通话关键词 编辑保存
export const getKeywordSave = param => {
	return request.post('/api/risk/keyword/save', param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};
//录音检测  处理记录
export const processing = param => {
	return request.post('/api/call/quality/processing', qs.stringify(param))
};

//录音检测列表
export const getCallQualityList = param => {
	return request.get('/api/call/quality/findAll?current=' + param.current + '&&size=' + param.size + '&&status=' +
		param.status + '&&riskTypeId=' + param.riskTypeId + '&&riskGradeId=' + param.riskGradeId +
		'&&agentId=' + param.agentId + '&&companyId=' + param.companyId + '&&startTime=' + param.startTime +
		'&&endTime=' + param.endTime + '&&isUse=' + param.isUse + '&&operation=' + param.operation)
};

//查询选项
export const getCategoryListQueryOptions = param => {
	return request.get('/api/risk/category/queryOptions')
};
//语音质检服务器列表
export const getOperationList = param => {
	return request.get('/api/ecs/operation/getAll')
};
//语音质检服务器列表
export const queryTypeOptions = param => {
	return request.get('/api/risk/category/queryOptions?type_id=' + param.type_id)
};
//语音质检服务器 添加和编辑
export const getAddOrUpdate = param => {
	return request.post('/api/ecs/operation/addOrUpdate', qs.stringify(param))
};
//通话关键字  预览分词
export const previewTerm = param => {
	return request.post('/api/risk/keyword/previewTerm', qs.stringify(param))
};
//语音质检服务器 删除
export const getDeleteServer = param => {
	return request.post('/api/ecs/operation/deleteServer', qs.stringify(param))
};
//语音质检服务器 开机关机
export const getOperation = param => {
	return request.post('/api/ecs/operation/startOrStop', qs.stringify(param))
};
//语音质检服务器 服务状态
export const serviceStatus = param => {
	return request.get('/api/ecs/operation/getServerStatus?instanceId=' + param.instanceId)
};
//语音质检服务器 重置计数
export const operationReset = param => {
	return request.get('/api/ecs/operation/reset')
};
//关键词类型 列表
export const getKeywordTypeList = param => {
	return request.get('/api/risk/category/findAll?category_name=' + param.category_name + '&&type_id=' + param
		.type_id + '&&current=' + param.current + '&&size=' + param.size)
};
//关键词类型 删除
export const getCategoryDelete = param => {
	return request.post('/api/risk/category/delete', qs.stringify(param))
};
//关键词类型 保存
export const getCategorySave = param => {
	return request.post('/api/risk/category/save', param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};
//下载客户磨板
export const downloadIntentionTemplate = param => {
	return request.post('/api/intentionCustomer/downloadIntentionTemplate', qs.stringify(param), {
		responseType: 'blob'
	})
};